import { types } from '../reducers/camerasPresentationReducer';



// eslint-disable-next-line import/prefer-default-export

export const updateForm = (values) => ({
  type: types.PUT,
  payload: values,
});


export { getDraftId } from '../reducers/camerasPresentationReducer';
